import Carousel from './components/Carousel';
import Thumbs from './components/Thumbs';
export { Carousel, Thumbs };